import { cryptoJSAesDecrypt } from '@/utils/secureAES'

const DEFAULT_DYNA_HOST = 'kyc.dyna.tech'

let cachedEnvSignature = ''
let cachedResolvedCredentials = null

function buildEnvSignature() {
  return [
    process.env.VUE_APP_DYNA_LIVE_WEB_ACCOUNT_ID_ENCRYPTED || '',
    process.env.VUE_APP_DYNA_LIVE_WEB_APP_KEY_ENCRYPTED || ''
  ].join('::')
}

function resolveEncryptedCredential(encryptedValue = '') {
  if (!encryptedValue) {
    return ''
  }

  return cryptoJSAesDecrypt(String(encryptedValue).trim())
}

export function getResolvedDynaLiveWebCredentials() {
  const currentSignature = buildEnvSignature()
  if (cachedResolvedCredentials && cachedEnvSignature === currentSignature) {
    return cachedResolvedCredentials
  }

  cachedEnvSignature = currentSignature
  cachedResolvedCredentials = {
    accountId: resolveEncryptedCredential(process.env.VUE_APP_DYNA_LIVE_WEB_ACCOUNT_ID_ENCRYPTED),
    appKey: resolveEncryptedCredential(process.env.VUE_APP_DYNA_LIVE_WEB_APP_KEY_ENCRYPTED)
  }

  return cachedResolvedCredentials
}

export function getResolvedDynaLiveWebConfig(baseConfig = {}) {
  const credentials = getResolvedDynaLiveWebCredentials()

  return {
    ...baseConfig,
    HOST: process.env.VUE_APP_DYNA_LIVE_WEB_HOST || baseConfig.HOST || DEFAULT_DYNA_HOST,
    ACCOUNT_ID: credentials.accountId,
    APP_KEY: credentials.appKey
  }
}

export function getResolvedDynaOcrInitConfig() {
  const { accountId, appKey } = getResolvedDynaLiveWebCredentials()

  if (!accountId || !appKey) {
    return {}
  }

  return {
    accountId,
    appKey,
    account_id: accountId,
    app_key: appKey
  }
}
